<app-cw-new-card
  [showHeader]="mode === appointmentConstant.PERSONAL_INFO"
  [showShadow]="mode === appointmentConstant.PERSONAL_INFO"
  customCardClass="{{ customCardClass }}"
  aria-label="Cart overview"
>
  <div header>
    <app-cw-card-header
      [title]="templateTitle | translation: templateContent.TEMPLATE_CONTENT: lang"
      [subtitle]="templateSubTitle | translation: templateContent.TEMPLATE_CONTENT: lang"
    />
  </div>

  <div
    body
    class="appointment-body"
    [ngClass]="{
      'my-4': mode === appointmentConstant.PERSONAL_INFO
    }"
    aria-label="Cart overview"
  >
    @if (cart.length <= 0) {
      <div>
        <div class="no-data" [attr.aria-label]="'appointments.step4.cart.emptyCartWarning' | translate">{{ 'appointments.step4.cart.emptyCartWarning' | translate }}</div>
      </div>
    }

    @if (cart.length > 0) {
      <div>
        @for (cartItem of cart; track cartItem; let i = $index; let last = $last) {
          <div class="row cw-cart-row">
            @if (getServicesByIds({serviceIds: cartItem.servicesIds}); as cartServices;) {
              <div class="col-12">
                <!-- Service Name -->
                <div
                  class="d-flex align-items-center"
                  [ngClass]="{
                    'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                  }"
                >
                  <div class="service">
                    <ngx-clamp row="3">
                      <div class="name" #content>
                      @for (service of cartServices; track service; let index = $index) {
                        <span class="cart">
                          <span>
                            {{ service | translation: 'name': lang }}
                          </span>
                          @if (index + 1 < cartServices.length) {
                            <span>, </span>
                          }
                        </span>
                      }
                      </div>
                    </ngx-clamp>
                  </div>
                </div>
              </div>

              <div
                [ngClass]="{
                  'col-lg-6': mode === appointmentConstant.PERSONAL_INFO,
                  'col-12': mode === appointmentConstant.SUMMARY
                }"
              >
                <!-- Service Name -->
                <div
                  class="appointment mt-1"
                  [ngClass]="{
                    'appointment-padding': mode === appointmentConstant.PERSONAL_INFO && cart.length !== 1,
                    'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                  }"
                >
                  <span class="cbw-summary-date-time">
                    {{ cartItem.date | date: 'dd.MM.y' }},
                    {{ cartItem.startTime | dateutc: timeFormat }} - {{ cartItem.endTime | dateutc: timeFormat }}
                    @if (cartItem?.location) {
                      <span>&nbsp;({{ cartItem?.location }})</span>
                    }
                  </span>
                  @if (
                      userState.meetingType &&
                      (widgetTemplates | calioMeetingTemplate: {
                        id: userState.meetingType.id,
                        type: 'meeting_template'
                      }); as widgetTemplate) {

                    <div
                      class="cbw-summary-meeting-type"
                      [innerHTML]="(widgetTemplate.titleTemplate | translation: templateContent.TEMPLATE_CONTENT: lang) | trustHtml"
                    ></div>
                    @if (userState.meetingType.id === 1 && cartItem) {
                      <div class="cbw-summary-worker-store-location">
                        <span class="cbw-summary-worker-store-location-name">{{ cartItem.store | translation: 'name' : lang }}</span>
                        @if (cartItem.store.is_online === 0) {
                          <span class="cbw-summary-worker-store-location-separator">,</span>
                          <span class="cbw-summary-worker-store-location-address whitespace-pre-line">
                            @let addressInput = {
                              street: cartItem.store.street,
                              zip: cartItem.store.zip,
                              city: cartItem.store.city,
                              country: cartItem.store.country | translation: 'name' : lang,
                              country_code: cartItem.store.country?.identifier
                            };
                            {{ addressInput | addressFormat: 'single' }}
                          </span>
                        }
                      </div>
                    }
                  } @else {
                    @if (userState?.meetingType?.id) {
                      <div [innerHTML]="(userState.meetingType | translation: 'name' : lang) | trustHtml"></div>
                    }
                  }
                </div>

                <div
                  class="d-none"
                  [ngClass]="{
                    'mt-1 d-lg-block': mode === appointmentConstant.PERSONAL_INFO,
                    'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                  }"
                >
                  <a class="remove-link" href="javascript:void(0)" (click)="removeFromCart(cartItem.cartItemId, cartItem.relatedAppointmentCardId)">
                    {{ 'buttons.remove' | translate }}
                  </a>
                </div>
              </div>

              <div
                [ngClass]="{
                  'col-lg-4': mode === appointmentConstant.PERSONAL_INFO,
                  'col-12': mode === appointmentConstant.SUMMARY
                }"
              >
                @if (partner.hide_mail_resource !== 1 && conferenceState?.uuid === undefined && !appointmentState?.isCombiServiceSelected) {
                  <div
                    class="worker-name"
                    [ngClass]="{
                      'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                    }"
                  >
                    {{ cartItem.workerName }}
                  </div>
                }
                <div
                  class="d-none"
                  [ngClass]="{
                    'mt-1 d-md-block d-lg-none': mode === appointmentConstant.PERSONAL_INFO,
                    'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                  }"
                >
                  <a class="remove-link" href="javascript:void(0)" (click)="removeFromCart(cartItem.cartItemId, cartItem.relatedAppointmentCardId)">
                    {{ 'buttons.remove' | translate }}
                  </a>
                </div>
              </div>

              @let totalPrice = cartItem.total.price / cartServices?.length;
              
              @if (totalPrice > 0 || totalPrice === 0) {
                <div
                  class="no-wrap cw-price text-md-end"
                  [ngClass]="{
                    'padding-inline-30px': mode === appointmentConstant.PERSONAL_INFO,
                    'col-lg-2': mode === appointmentConstant.PERSONAL_INFO,
                    'col-12': mode === appointmentConstant.SUMMARY
                  }"
                >
                  @if (totalPrice > 0) {
                    <span>
                      @if (cartItem.total.isPriceFromActivated) {
                        <span>
                          {{ 'common.price_from_label' | translate }}
                        </span>
                      }
                      {{ cartItem.total.price | calioCurrency: partner?.currency: lang }}
                      @if (cartItem.total?.tax >= 0) {
                        <div class="cbw-taxes">
                          @if (isVatAddedOnTop(partner.widget_vat_type) && getItemVatAmount(cartItem, totalPrice) > 0) {
                            + {{ getItemVatAmount(cartItem, totalPrice) | calioCurrency: partner?.currency: lang }}
                          }
                          ({{ 'tax_info.' + vatTypeLabelKey(partner.widget_vat_type) | translate }}
                          @if (vatTypeLabelKey(partner.widget_vat_type) !== 'exclude') {
                            <span class="cbw-taxes-percentage">{{ getItemVatRates(cartItem) }}</span>
                          }
                          {{ 'tax_info.taxes' | translate }})
                        </div>
                      }
                    </span>
                  }
                  @if (totalPrice === 0) {
                    <span>
                      {{ 'free' | translate }}
                    </span>
                  }
                  @if (totalPrice === -1) {
                    <span> &nbsp; </span>
                  }
                </div>
              }

              <div
                class="d-block"
                [ngClass]="{
                  'col-lg-12 d-md-none': mode === appointmentConstant.PERSONAL_INFO,
                  'col-12': mode === appointmentConstant.SUMMARY
                }"
              >
                <div
                  class="mt-1"
                  [ngClass]="{
                    'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                  }"
                >
                  <a class="remove-link" href="javascript:void(0)" (click)="removeFromCart(cartItem.cartItemId,cartItem.relatedAppointmentCardId)">
                    {{ 'buttons.remove' | translate }}
                  </a>
                </div>
              </div>

              @if ((finalCouponDiscount > 0 || finalTotal !== 0 && cart && cart.length > 0) || (cart && cart.length > 1 && !last)) {
                <div class="col-12">
                  <hr class="card-divider w-100" />
                </div>
              }
            }
          </div>
        }

        @for (relatedAppointmentService of relatedAppointmentServices; track relatedAppointmentService; let i = $index; let last = $last) {
          @if (!relatedAppointmentService?.isAddedToCart) {
            <div class="row cw-cart-row mt-3">
              <div class="col-lg-6 service">
                <div
                  class="appointment"
                  [ngClass]="{
                    'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                  }"
                  [innerHTML]="(
                    (widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_COMBINED_BOOKING_TEXT, type: 'template' }) | translation: templateContent.TEMPLATE_CONTENT: lang
                      : [{
                        key: '[SERVICE_NAME]',
                        value: (relatedAppointmentService?.originalAppointmentService | translation: 'name': lang)
                      },
                      {
                        key: '[RELATED_SERVICE_NAME]',
                        value: (relatedAppointmentService?.relatedServiceData | translation: 'name': lang)
                      }]
                  ) | trustHtml"
                ></div>
              </div>
              <div class="col-lg-6 mt-2 mt-lg-0">
                @for (afterDateFreeAppointment of relatedAppointmentService?.allDates; track afterDateFreeAppointment) {
                  <div
                    class="appointment d-flex align-items-center mb-1"
                    [ngClass]="{
                      'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                    }"
                  >
                    <span class="me-1">
                      <span>
                      {{ afterDateFreeAppointment.start | date:'dd.MM.y,' }}&nbsp;
                      {{ afterDateFreeAppointment.start | dateutc:timeFormat }} -
                      {{ afterDateFreeAppointment.end | dateutc:timeFormat }}
                      </span>
                      (<span>{{ afterDateFreeAppointment?.worker?.resource_name }}</span>)
                    </span>
                    (<a
                      href="javascript:void(0)"
                      class="remove-link"
                      (click)="onSelectSlot(relatedAppointmentService, afterDateFreeAppointment)"
                    >
                      {{ 'add' | translate }}
                    </a>)
                  </div>
                }
              </div>
              <div class="col-12">
                <hr class="card-divider w-100" />
              </div>
            </div>
          }
        }

        @if (customFields?.length) {
          <div class="row cw-cart-row cbw-addons-custom-fields-wrapper">
            <div 
              class="cbw-addons-custom-fields"
              [ngClass]="{
                'cbw-addons-personal-info-view': mode === appointmentConstant.PERSONAL_INFO,
                'px-0 cbw-addons-summary-view': mode === appointmentConstant.SUMMARY
              }"
            >
              <app-customfields
                [(userState)]="userState"
                [globals]="globals"
                [customFields]="customFields"
                [partner]="partner"
                [selectedJsonCustomFields]="selectedJsonCustomFields"
                [lang]="lang"
                [widgetTemplates]="widgetTemplates"
                [customFieldValues]="customFieldValues"
                [customFieldValuesLSNameKey]="customFieldValuesLSNameKey"
              />
            </div>
          </div>
        }

        @if (finalCouponDiscount > 0 || finalTotal !== 0 && cart && cart.length > 0) {
          <div class="row cw-cart-row">
            <div
              [ngClass]="{
                'col-lg-6 col-md-6': mode === appointmentConstant.PERSONAL_INFO,
                'col-12': mode === appointmentConstant.SUMMARY
              }"
            ></div>
            <div
              [ngClass]="{
                'col-lg-6 col-md-6': mode === appointmentConstant.PERSONAL_INFO,
                'col-12': mode === appointmentConstant.SUMMARY
              }"
            >
              @if (_customFieldsAddonsPrice > 0) {
                <div class="d-flex justify-content-start justify-content-md-end cbw-addons-custom-fields-subtotal-wrapper">
                  <div class="row total-row cw-cart-row cbw-addons-custom-fields-subtotal-row padding-inline-15px">
                    <div class="col-lg-7 col-md-7 bold-field-label cbw-addons-custom-fields-subtotal-label">
                      {{ widgetTemplates | calioMeetingTemplate: { id: templateConstant.ADDON_UPGRADE_LABEL, type: 'template' } | translation: templateContent.TEMPLATE_CONTENT: lang }}
                    </div>
                    <div class="col-lg-5 col-md-5 text-md-end bold-field-label cbw-addons-custom-fields-subtotal-price padding-inline-15px">
                      <span>
                        {{ _customFieldsAddonsPrice | calioCurrency: partner?.currency: lang }}
                      </span>
                  </div>
                  </div>
                </div>
              }
              @if (vatTypeLabelKey(partner?.widget_vat_type) !== 'exclude' || coupon) {
                <div class="d-flex justify-content-start justify-content-md-end cbw-subtotal-wrapper">
                  <div class="row total-row cw-cart-row cbw-subtotal-row padding-inline-15px">
                    <div class="col-lg-7 col-md-7 bold-field-label cbw-subtotal-label">
                      {{ subtotalLabelKey() | translate }}
                    </div>
                    <div class="col-lg-5 col-md-5 text-md-end bold-field-label cbw-subtotal-price padding-inline-15px">
                      <span>
                        @if (_totalCartPrice > 0) {
                          {{ _totalCartPrice | calioCurrency: partner?.currency: lang }}
                        } @else if (_totalCartPrice  === 0) {
                          {{ 'free' | translate }}
                        } @else if (_totalCartPrice === -1) {
                          &nbsp;
                        }
                      </span>
                  </div>
                  </div>
                </div>
              }

              @if (coupon) {
                <div class="d-flex justify-content-start justify-content-md-end mt-2 cbw-coupon-wrapper">
                  <div
                    class="row total-row cw-cart-row cbw-coupon-row"
                    [ngClass]="{
                      'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                    }"
                  >
                    <div class="col-lg-7 col-md-7 normal-field-label cbw-coupon-label">
                      {{ 'coupon_credit_card_info.coupon' | translate }} ({{ coupon.code }})
                    </div>
                    <div
                      class="col-lg-5 col-md-5 text-md-end normal-field-label cbw-coupon-price"
                      [ngClass]="{
                        'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                      }"
                    >
                      <span>
                        - {{ finalCouponDiscount | calioCurrency: partner?.currency: lang }}
                      </span>
                    </div>
                  </div>
                </div>
              }

              @if (isVatAddedOnTop(partner.widget_vat_type)) {
                @for (rate of vat().byRate; track rate.rate) {
                  <div class="d-flex justify-content-start justify-content-md-end cbw-vat-wrapper">
                    <div
                      class="row total-row cw-cart-row cbw-vat-row"
                      [ngClass]="{
                        'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                      }"
                    >
                      <div class="col-lg-7 col-md-7 normal-field-label cbw-vat-label">
                        {{ 'tax_info.tax_line' | translate: { percentage: rate.rate } }}
                      </div>
                      <div
                        class="col-lg-5 col-md-5 text-md-end normal-field-label cbw-vat-price"
                        [ngClass]="{
                          'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                        }"
                      >
                        <span>
                          + {{ (rate.amountCents / 100) | calioCurrency: partner?.currency: lang }}
                        </span>
                      </div>
                    </div>
                  </div>
                }
              } @else {
                @for (rate of containedVat().byRate; track rate.rate) {
                  <div class="d-flex justify-content-start justify-content-md-end cbw-vat-wrapper">
                    <div
                      class="row total-row cw-cart-row cbw-vat-row"
                      [ngClass]="{
                        'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                      }"
                    >
                      <div class="col-lg-7 col-md-7 normal-field-label cbw-vat-label">
                        {{ 'tax_info.tax_included_line' | translate: { percentage: rate.rate } }}
                      </div>
                      <div
                        class="col-lg-5 col-md-5 text-md-end normal-field-label cbw-vat-price"
                        [ngClass]="{
                          'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                        }"
                      >
                        <span>
                          {{ (rate.amountCents / 100) | calioCurrency: partner?.currency: lang }}
                        </span>
                      </div>
                    </div>
                  </div>
                }
              }

              <div class="d-flex justify-content-start justify-content-md-end cbw-total-wrapper">
                <div
                  class="row total-row cw-cart-row cbw-total-row"
                  [ngClass]="{
                    'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                  }"
                >
                  <div class="col-12">
                    <hr class="card-divider w-100" />
                  </div>
                  <div class="col-lg-7 col-md-7 bold-field-label cbw-total-label">
                    {{ totalLabelKey() | translate }}
                  </div>
                  <div
                    class="col-lg-5 col-md-5 text-md-end bold-field-label cbw-total-price"
                    [ngClass]="{
                      'padding-inline-15px': mode === appointmentConstant.PERSONAL_INFO
                    }"
                  >
                    @if (!finalCouponDiscount) {
                      <span>
                        {{ finalTotal | calioCurrency: partner?.currency: lang }}
                      </span>
                    }
                    @if (finalCouponDiscount && finalCouponDiscount < _totalCartPrice) {
                      <span>
                        {{ finalTotal | calioCurrency: partner?.currency: lang }}
                      </span>
                    }
                    @if (finalCouponDiscount && finalCouponDiscount >= _totalCartPrice) {
                      <span>
                        {{ 'free' | translate }}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</app-cw-new-card>
